import type {
  AddToWishlistRequest,
  AddToWishlistResponse,
  GetWishlistRequest,
  GetWishlistResponse,
  MigrateWishlistRequest,
  MigrateWishlistResponse,
  RemoveFromWishlistRequest,
  RemoveFromWishlistResponse,
} from './utils/types';
import { client } from '../common/client';

class WishlistAPIClient {
  public async getWishlist(request: GetWishlistRequest): Promise<GetWishlistResponse> {
    return await client
      .get(`/wishlist`, {
        params: request,
      })
      .then((res) => res.data);
  }

  public async addProductToWishlist(payload: AddToWishlistRequest): Promise<AddToWishlistResponse> {
    return await client.post(`/wishlist/addProduct`, payload).then((res) => res.data);
  }

  public async removeProductFromWishlist(payload: RemoveFromWishlistRequest): Promise<RemoveFromWishlistResponse> {
    return await client.delete(`/wishlist/removeProduct`, { data: payload }).then((res) => res.data);
  }

  public async migrateWishlist(payload: MigrateWishlistRequest): Promise<MigrateWishlistResponse> {
    return await client.post(`/wishlist/migrate`, payload).then((res) => res.data);
  }
}

export const wishlistAPIClient = new WishlistAPIClient();
